import { useSelector } from 'react-redux';

import {
  ContractDateFormat,
  DEFAULT_CONTRACT_DATE_FORMAT,
} from 'src/constants/dateConsts';
import { RootState } from 'src/store';

export const useContractDateFormat = (): ContractDateFormat => {
  const dateFormat = useSelector(
    (state: RootState) => state.settings.contractSettings?.dateFormat,
  );

  return dateFormat || DEFAULT_CONTRACT_DATE_FORMAT;
};
